<template>
  <div class="filter-box" :class="{ isClosed: isClosed }">
    <v-expansion-panels :value="open" @change="changeOpen">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="collapsable-header">
            <div class="bold">Anzahl Personen</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="collapsable-inner">
            <div class="filter-content">
              <v-range-slider
                v-model="range"
                max="20"
                min="0"
                thumb-color="#33bbff"
                color="#33bbff"
                track-color="#ddf5fe"
                track-fill-color="#7fd8f9"
                @input="onChangeRange($event)"
              ></v-range-slider>
              <div class="input-values">
                <p>von</p>
                <input :value="range[0]" v-on:blur="changeRange($event, 0)" />
                <p>bis</p>
                <input :value="range[1]" v-on:blur="changeRange($event, 1)" />
              </div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: ["filters", "open"],
  data() {
    return {
      range: [0, 20],
      isClosed: true,
    };
  },
  watch: {},
  methods: {
    changeRange(e, i) {
      let tmpRange;
      if (i === 0) {
        tmpRange = [parseInt(e.srcElement.value), this.range[1]];
      } else {
        tmpRange = [this.range[0], parseInt(e.srcElement.value)];
      }
      this.range = tmpRange;

      this.$emit("input", tmpRange);
    },
    onChangeRange(values) {
      this.range = values;
      this.$emit("input", values);
    },
    changeOpen(val) {
      this.$emit("open", val);
    },
  },
  mounted() {
    // this.category = JSON.parse(this.category);
    console.log("mounted filters");
  },
  created() {
    // console.log(JSON.parse(this.category));
  },
  computed: {},
};
</script>

<style>
</style>
